import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from './cn.js';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return (
      <input
        ref={ref}
        {...rest}
        className={cn(
          'h-12 w-full rounded-xl border border-line bg-surface-2 px-4 text-base text-text placeholder:text-text-muted',
          'focus:outline-none focus:border-gold/40 focus:bg-surface-3 transition',
          className,
        )}
      />
    );
  },
);
